import React from 'react';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { useTranslation } from "react-i18next";
import MenuItems from './MenuItems';
import MegaMenu from './MegaMenu';
import { showHidden } from "Components/API";

const Navbar = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    const renderMenuItem = (menuItem, index) => {
        const shouldRender =
            (!menuItem.showOnlyinFA || currentLang === "fa") &&
            (!menuItem.hideInDemo || !showHidden) &&
            (showHidden || !menuItem.showInDemo);

        if (!shouldRender) return null;

        if (menuItem.hasSubMenu) {
            return (
                <li className="nav-item dropdown has-megamenu" key={index}>
                    <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                        {t(menuItem.label)}
                        <ExpandMoreOutlinedIcon />
                    </a>
                    <MegaMenu menuItem={menuItem} />
                </li>
            );
        }

        return (
            <li key={index}>
                <a className="nav-link px-0" href={menuItem.link}>
                    {t(menuItem.label)}
                    {menuItem.comingSoon && <span className="coming-soon">{t("progress")}</span>}
                </a>
            </li>
        );
    };

    return (
        <nav className="navbar navbar-expand flex-grow-1 p-0 position-static">
            <div className="w-100 flex-nowrap mb-1">
                <div className="collapse navbar-collapse col flex-grow-1 w-100 justify-content-center" id="main_nav">
                    <ul className="navbar-nav px-0 mainMenu">
                        {MenuItems.map((menuItem, index) => renderMenuItem(menuItem, index))}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;